define([
	'jquery',
	'libs/socket.io',
	'models/blockpage.model',
	'views/blockpage.view',
	'libs/megadrop',
	'components/parallax/parallax',
	'components/infinityscroll/infinityscroll',
	'libs/caroufredsel/helper-plugins/jquery.touchSwipe.min',
	'libs/scrollreveal.min',
	'libs/acf-maps',
	'libs/ba-tiny-pubsub.min',
	'libs/jquery.meanmenu',
	'libs/caroufredsel/jquery.carouFredSel-6.2.1-packed',
	'libs/fancybox/jquery.fancybox',
	'libs/jquery.imagesloaded.min'
], function ($, io, BlockpageModel, BlockpageView, megadrop, parallax, infinityscroll, touchswipe, scrollreveal) {
	'use strict';

	/**
	 * App
	 * This is the initialization file for all scripts.
	 * @version 2.0.0
	 * @see {@link http://youmightnotneedjquery.com/}
	 * @exports app
	 */
	var app = {

		trojaContent: {},

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			// Dom ready
			$(document).ready($.proxy(this.domReady(), this));
		},

		domReady: function () {
			// summary:
			//		domReady
			// description:
			//		Function that runs when the dom is ready.

			// Init Megadrop
			megadrop.init();

			// Init Meanmenu
			this.initMeanmenu();

			// Init caroufredsel
			this.initcaroufredsel();

			// Init Videoplayer
			this.initVideoplayer();

			// Open external links in new window
			this.openExternalLinksInNewWindow();

			// Init parallax
			parallax.init();

			this._initPrintButtons();

			// Init anchor scrolling
			this._initAnchorScroll();

			this._initFancybox();

			this._initSubscriptions();

			// Init search toggle
			this._initSearchToggle();

			// Init Scrolltotop
			this._initScrolltotop();

			// Init Scrollreveal
			this.scrollreveal();

			var that = this;
			this._initBlockpageJson(function () {
				that._initSocketIo();
				if ($('#blockpage-holder').length > 0) {
					that._initBlockpage();
				}
			});

			if ($('[data-type="infinityscroll"]').length > 0) {
				infinityscroll.init();
			}

			$('body').on('click', '.plus .cd-timeline-img', function (event) {
				$('.cd-timeline-block').show();
				$('.plus').hide();
			});
		},

		_initPrintButtons: function () {
			$('.print-main-content').on('click', function () {
				var restorepage = document.body.innerHTML,
					printcontent = $(this).closest('.main-content').html();
				document.body.innerHTML = printcontent;
				window.print();
				document.body.innerHTML = restorepage;
			});
		},


		_initAnchorScroll: function () {
			var pathname = window.location.pathname,
				searchTerm = new RegExp('/', 'g'),
				articleId = 'article-series-' + pathname.split('/')[pathname.split('/').length - 2];
			if ($('#' + articleId).length > 0) {
				$('html, body').animate({scrollTop: $('#' + articleId).offset().top}, 'slow');
			}
		},


		_initBlockpageJson: function (callback) {
			var that = this;
			$.ajax({
				cache: false,
				url: mainConfig.jsonUrl,
				dataType: 'json',
				success: function (data) {
					that.trojaContent = data;
					callback();
				}
			});
		},


		_initBlockpage: function () {
			// summary:
			//		initBlockpage
			// description:
			//		Init blockpage.

			this.Model = new BlockpageModel(this.trojaContent);
			this.View = new BlockpageView({$el: $('#blockpage-holder'), model: this.Model});
		},


		_initSocketIo: function () {
			// summary:
			//		_initSocketIo
			// description:
			//		Setup and listen for socket messages, publish the messages to other scripts.

			this.socket = io(mainConfig.socketUrl);

			this.socket.on('pageChanged', function (data) {
				$.publish('pageChanged', data);
			});
		},


		initcaroufredsel: function () {
			$('[data-type="caroufredsel"]:not([data-initiated="true"])').each(function () {
				var $this = $(this),
					visible = $this.data('carousel-visible') !== undefined ? parseInt($this.data('carousel-visible'), 10) : 1;
				$(this).imagesLoaded(function () {
					$(this).carouFredSel({
						//responsive: true,
						direction: 'left',
						width: '100%',
						height: 'variable',
						infinite: true,
						auto: false,
						items: {
							visible: {
								min: 1,
								max: visible
							},
							height: 'variable',
							width: 'variable'
						},
						scroll: {
							items: 1
						},
						prev: {
							button: function () {
								return $(this).parent().parent().find('.carousel-nav').find('.carousel-nav-prev');
							}
						},
						next: {
							button: function () {
								return $(this).parent().parent().find('.carousel-nav').find('.carousel-nav-next');
							}
						},
						onCreate: function () {
							$('.carousel-nav-prev').show();
							$('.carousel-nav-next').show();
						}
					});

					$(this).attr('data-initiated', 'true');
					$(this).addClass('caroufredsel-initiated');

					if ($this.children('li').length === 1) {
						$this.parent().parent().find('.carousel-nav').remove();
					} else {
						$this.parent().parent().find('.carousel-nav').show();
					}
				});
			});
		},


		initMeanmenu: function () {
			// summary:
			//		initMeanmenu
			// description:
			//		Initiates the Meanmenu plugin (fixes a nice mobile menu).

			$('header nav .menu').meanmenu({
				meanScreenWidth: 767,
				removeElements: '.no-nav .block, .no-nav',
				meanRemoveAttrs: true
			});
		},


		initVideoplayer: function () {
			// summary:
			//		initVideoplayer
			// description:
			//		Initiates the Videoplayer

			$('.video-list a').on('click', function (event) {
				$('#video-player iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).data('youtubeid'));
			});
		},


		openExternalLinksInNewWindow: function () {
			$('a[href^="http://"]').filter(function () {
				return this.hostname && this.hostname !== location.hostname;
			}).attr('target', '_blank');
		},


		_initFancybox: function () {
			// summary:
			//		_initFancybox
			// description:
			//		Setup fancybox.

			$('[data-type="fancybox"]').fancybox({
				helpers: {
					overlay: {
						locked: false
					}
				}
			});
		},


		_initSearchToggle: function () {
			// summary:
			//		_initSearchToggle
			// description:
			//		Initiates the search toggle.

			$('[data-type="site-search-toggle"]').on('click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

				var $target = $(this).next('[data-type="site-search"]');

				if ($target.length === 0) {
					$target = $(this).parent('[data-type="site-search"]');
				}

				if ($target.hasClass('is-hidden')) {
					$target.removeClass('is-hidden');
					setTimeout(function () {
						$target.addClass('is-visible');
						$target.find('input[type="text"]').focus();
					}, 10);
				} else {
					$target.removeClass('is-visible');
					setTimeout(function () {
						$target.addClass('is-hidden');
					}, 400);
				}
			});
		},


		_initSubscriptions: function () {
			var that = this;
			$.subscribe('initPageScripts', function (event, data) {
				that.initcaroufredsel();
				parallax.init();
			});
		},


		_initScrolltotop: function () {
			$(window).scroll(function () {
				if ($(this).scrollTop() > 100) {
					$('.scrollup').fadeIn();
				} else {
					$('.scrollup').fadeOut();
				}
			});

			$('.scrollup').click(function () {
				$('html, body').animate({
					scrollTop: 0
				}, 600);
				return false;
			});
		},


		scrollreveal: function () {
			window.sr = scrollreveal();
			sr.reveal('.block-carousel-package', {duration: 1000});
			sr.reveal('.img-block-carousel-package', {duration: 1000});
			sr.reveal('.is-red', {duration: 1000});
			sr.reveal('.table-container', {duration: 1000});
			sr.reveal('.image-home-latest', {duration: 1000});
			sr.reveal('.image-away-latest', {duration: 1000});
		}
	};

	return app;
});



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 1
// module chunks = 0